import React from "react";
import { FormControl, TextField } from "@mui/material";
import { Controller } from "react-hook-form";

/**
 * @param {{
 *  label?: string;
 *  name: string;
 *  control: any;
 *  rules?: any;
 *  defaultValue?: string;
 *  type?: string;
 *  size?: "small" | "medium";
 *  [key: string]: any;
 * }} props
 */
export const FormTextField = ({
  label,
  name,
  control,
  rules = {},
  defaultValue = "",
  type = "text",
  size = "small",
  InputProps = {},
  ...props
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({
        field: { ref, value, ...restInputProps },
        fieldState: { error },
      }) => (
        <FormControl fullWidth error={!!error}>
          <TextField
            value={value ?? ""}
            size={size}
            type={type}
            label={label}
            error={!!error}
            // @ts-ignore
            helperText={error?.message}
            inputRef={ref}
            InputProps={{
              spellCheck: false,
              ...InputProps,
            }}
            {...restInputProps}
            {...props}
            variant={props.disabled ? "filled" : "outlined"}
          />
        </FormControl>
      )}
    />
  );
};
